module.exports = new __parcel__URL__("jsw-storage-limit.6d661396.png").toString();